import { render, staticRenderFns } from "./DashboardCleaning.vue?vue&type=template&id=393f5d63&scoped=true"
import script from "./DashboardCleaning.vue?vue&type=script&lang=js"
export * from "./DashboardCleaning.vue?vue&type=script&lang=js"
import style0 from "./DashboardCleaning.vue?vue&type=style&index=0&id=393f5d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f5d63",
  null
  
)

export default component.exports